import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import { VehiclePricingRequestCounts } from "../../types/VehiclePricingRequest";

export const getQuoteDealerPricingRequestCounts = (
  quoteId: string,
  options: APQueryOptions = {}
) => {
  const { fetchWithAuth } = useApi();
  const { isQueryEnabled, defaultOnMutateError } = useAPQuery();

  return useQuery({
    queryKey: ["quoteDealerPricingRequestCounts", quoteId],
    queryFn: (): Promise<VehiclePricingRequestCounts> => {
      return fetchWithAuth<VehiclePricingRequestCounts>(
        "getQuoteDealerPricingRequestCounts",
        quoteId
      );
    },
    enabled: isQueryEnabled(options),
    onError: defaultOnMutateError(options),
  });
};
